import React from 'react';
import ForgotPassword from '../../components/Auth/ForgotPassword';
import './styles.scss';

const ForgotPasswordPage = (props: any) => {
    return <ForgotPassword />
  }
  
  export default ForgotPasswordPage;